import React from "react"
import { InspectionContext } from "../../context"
import Inspection from "../../models/inspection"
import { Form as FormType } from "../../models/new/forms.types"

type TProps = {
  children: React.ReactNode
}

const InspectionProvider = (props: TProps) => {
  const [inspections, setInspections] = React.useState<undefined | Inspection[]>(undefined)
  const [archivedInspections, setArchivedInspections] = React.useState<undefined | Inspection[]>(
    undefined,
  )
  const [inspectionForms, setInspectionForms] = React.useState<undefined | FormType[]>(undefined)

  return (
    <React.Fragment>
      <InspectionContext.Provider
        value={{
          inspections,
          setInspections,
          archivedInspections,
          setArchivedInspections,
          inspectionForms,
          setInspectionForms,
        }}
      >
        {props.children}
      </InspectionContext.Provider>
    </React.Fragment>
  )
}

export default InspectionProvider
